import React from 'react'
import { convertShortcodesToHTML } from '../../../services/common'
import Parser from '../parser/Parser'

const Paragraph = ({ block }) => {
    return (
        <article className="baseocom-paragraph-block">
            {block?.content && (
                <p className={`${block?.style === 'muted' ? 'baseocom-small' : 'baseocom-text'}`}>
                    {convertShortcodesToHTML(block?.content)}
                </p>
            )}
            {block?.childrens && <Parser content_block={block?.childrens} />}
        </article>
    )
}
export default Paragraph
